import { render, staticRenderFns } from "./DetalhesItem.vue?vue&type=template&id=4a249d22&"
import script from "./DetalhesItem.vue?vue&type=script&lang=js&"
export * from "./DetalhesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports